/* Earth Revibe — global chrome behavior (vanilla port of the Next.js storefront) */
(function () {
  'use strict';

  var ER = (window.ER = window.ER || {});

  /* ---------- scroll lock ---------- */
  ER.lock = function () {
    document.documentElement.classList.add('er-lock');
  };
  ER.unlock = function () {
    document.documentElement.classList.remove('er-lock');
  };

  /* ---------- Lenis smooth scroll — desktop + fine pointer only ---------- */
  function initLenis() {
    if (typeof window.Lenis !== 'function') return;
    var mq = window.matchMedia('(pointer: fine) and (min-width: 1024px)');
    var lenis = null;
    var rafId = null;

    function raf(time) {
      if (lenis) {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      }
    }
    function enable() {
      if (lenis) return;
      lenis = new window.Lenis({
        lerp: 0.04,
        duration: 1.6,
        smoothWheel: true,
        wheelMultiplier: 0.8,
        autoResize: true,
      });
      rafId = requestAnimationFrame(raf);
    }
    function disable() {
      if (!lenis) return;
      lenis.destroy();
      lenis = null;
      if (rafId) cancelAnimationFrame(rafId);
    }
    function sync(m) {
      if (m.matches) enable();
      else disable();
    }
    sync(mq);
    mq.addEventListener('change', sync);
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'auto';
    }
  }

  /* ---------- header: scrolled + transparent-over-hero ---------- */
  function initHeader() {
    var header = document.querySelector('.er-header');
    if (!header) return;
    var isHome = document.body.classList.contains('template-index');

    function update() {
      var scrolled = window.scrollY > 10;
      header.classList.toggle('is-scrolled', scrolled);
      if (isHome) {
        var covers = document.getElementById('home-covers');
        var pastCovers = true;
        if (covers) pastCovers = covers.getBoundingClientRect().bottom <= 64;
        header.classList.toggle('is-transparent', !pastCovers);
      }
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  /* ---------- announcement bar ---------- */
  var ANNOUNCE_KEY = 'er:announcement-dismissed';
  function initAnnouncement() {
    var bar = document.querySelector('.er-announcement');
    if (!bar) return;
    if (localStorage.getItem(ANNOUNCE_KEY) === '1') {
      bar.remove();
      return;
    }
    var msgs = [];
    try {
      msgs = JSON.parse(bar.getAttribute('data-messages') || '[]');
    } catch (e) {
      msgs = [];
    }
    var el = bar.querySelector('.er-announcement__msg');
    if (!el || msgs.length < 2) return;
    var idx = 0;
    setInterval(function () {
      el.classList.add('is-hidden');
      setTimeout(function () {
        idx = (idx + 1) % msgs.length;
        el.textContent = msgs[idx];
        el.classList.remove('is-hidden');
      }, 300);
    }, 4000);
  }

  /* ---------- drawers ---------- */
  function openDrawer(root) {
    if (!root) return;
    root.hidden = false;
    ER.lock();
  }
  function closeDrawer(root) {
    if (!root) return;
    root.hidden = true;
    ER.unlock();
  }

  ER.openCart = function () {
    openDrawer(document.getElementById('er-cart'));
  };
  ER.closeCart = function () {
    closeDrawer(document.getElementById('er-cart'));
  };

  /* ---------- cart engine (Shopify AJAX + Section Rendering) ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.setAttribute('data-count', String(count));
    });
  }

  function swapCartSection(html) {
    var wrapper = document.getElementById('shopify-section-cart-drawer');
    if (!wrapper || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('shopify-section-cart-drawer');
    var wasOpen = !document.getElementById('er-cart').hidden;
    if (fresh) wrapper.innerHTML = fresh.innerHTML;
    if (wasOpen) {
      var root = document.getElementById('er-cart');
      if (root) root.hidden = false;
    }
    applyStashedDiscount();
  }

  ER.refreshCart = function () {
    fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        swapCartSection(data['cart-drawer']);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (cart) updateCartCount(cart.item_count);
      })
      .catch(function () {});
  };

  function cartChange(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: 'cart-drawer',
        sections_url: '/',
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (cart.sections) swapCartSection(cart.sections['cart-drawer']);
      })
      .catch(function () {});
  }

  ER.addToCart = function (id, quantity, properties) {
    var payload = {
      items: [{ id: Number(id), quantity: quantity || 1 }],
      sections: 'cart-drawer',
      sections_url: '/',
    };
    if (properties) payload.items[0].properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (res) {
        if (res.sections) swapCartSection(res.sections['cart-drawer']);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (cart) updateCartCount(cart.item_count);
        ER.openCart();
        return cart;
      });
  };

  /* ---------- discount code (applied at checkout via /discount/CODE) ---------- */
  var DISCOUNT_KEY = 'er:discount-code';
  function applyStashedDiscount() {
    var code = localStorage.getItem(DISCOUNT_KEY) || '';
    var field = document.querySelector('[data-discount-form]');
    var applied = document.querySelector('[data-discount-applied]');
    var label = document.querySelector('[data-discount-code-label]');
    var checkout = document.querySelector('[data-checkout-link]');
    if (applied && field) {
      applied.hidden = !code;
      field.hidden = !!code;
      if (label) label.textContent = code;
    }
    if (checkout) {
      checkout.setAttribute(
        'href',
        code ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout' : '/checkout'
      );
    }
  }

  function handleDiscountApply() {
    var input = document.querySelector('[data-discount-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) return;
    localStorage.setItem(DISCOUNT_KEY, code);
    fetch('/discount/' + encodeURIComponent(code)).then(function () { ER.refreshCart(); }).catch(function () {});
    applyStashedDiscount();
  }

  /* ---------- wishlist ----------
     Guest-first: the storefront's wishlist is server-backed behind auth, which
     Shopify has no equivalent for. Handles live in localStorage; the page
     rehydrates each one from /products/{handle}.js so prices/stock stay live. */
  var WISHLIST_KEY = 'er:wishlist';

  function getWishlist() {
    try {
      var raw = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      return Array.isArray(raw) ? raw.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }
  function setWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {}
    syncHearts(document);
    updateWishCount();
  }
  ER.wishlist = getWishlist;
  ER.toggleWishlist = function (handle) {
    if (!handle) return false;
    var list = getWishlist();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    setWishlist(list);
    return i === -1;
  };

  function syncHearts(scope) {
    var list = getWishlist();
    (scope || document).querySelectorAll('[data-wish-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wish-toggle')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function updateWishCount() {
    var n = getWishlist().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.setAttribute('data-count', String(n));
      el.textContent = n > 9 ? '9+' : String(n);
    });
  }

  /* ---------- wishlist page ---------- */
  function initWishlistPage() {
    var root = document.querySelector('[data-wish-page]');
    if (!root) return;
    var grid = root.querySelector('[data-wish-grid]');
    var empty = root.querySelector('[data-wish-empty]');
    var head = root.querySelector('[data-wish-head]');
    var countEl = root.querySelector('[data-wish-total]');

    function render() {
      var handles = getWishlist();
      if (!handles.length) {
        grid.innerHTML = '';
        grid.hidden = true;
        head.hidden = true;
        empty.hidden = false;
        return;
      }
      empty.hidden = true;

      Promise.all(
        handles.map(function (h) {
          return fetch('/products/' + encodeURIComponent(h) + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        })
      ).then(function (products) {
        // Drop handles that 404 (product deleted/unpublished) so the list self-heals.
        var live = [];
        var alive = [];
        products.forEach(function (p, i) {
          if (p) { live.push(p); alive.push(handles[i]); }
        });
        if (alive.length !== handles.length) {
          try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(alive)); } catch (e) {}
          updateWishCount();
        }
        if (!live.length) {
          grid.innerHTML = '';
          grid.hidden = true;
          head.hidden = true;
          empty.hidden = false;
          return;
        }
        head.hidden = false;
        grid.hidden = false;
        countEl.textContent = live.length + (live.length === 1 ? ' item' : ' items');
        grid.innerHTML = live.map(cardHtml).join('');
      });
    }

    function money(cents) {
      return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function img(src, w) {
      if (!src) return '';
      return src.replace(/(\.[a-z]{3,4})(\?|$)/i, '_' + w + 'x$1$2');
    }

    function cardHtml(p) {
      var v = (p.variants || []).find(function (x) { return x.available; }) || (p.variants || [])[0] || {};
      var inStock = !!p.available;
      var compare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : null;
      return (
        '<div class="er-wish__item">' +
          '<a class="er-wish__imgwrap" href="/products/' + esc(p.handle) + '">' +
            (p.featured_image
              ? '<img src="' + esc(img(p.featured_image, 400)) + '" alt="' + esc(p.title) + '" loading="lazy" width="300" height="400">'
              : '') +
            (inStock ? '' : '<span class="er-wish__oos"><span>SOLD OUT</span></span>') +
          '</a>' +
          '<a class="er-wish__name" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
          '<div class="er-wish__price">' +
            '<span class="v">' + money(v.price || p.price) + '</span>' +
            (compare ? '<span class="c">' + money(compare) + '</span>' : '') +
          '</div>' +
          (inStock && v.id
            ? '<button type="button" class="er-wish__add" data-wish-add="' + v.id + '">ADD TO BAG</button>'
            : '<div class="er-wish__soldout"><span>SOLD OUT</span></div>') +
          '<button type="button" class="er-wish__remove" data-wish-remove="' + esc(p.handle) + '">Remove</button>' +
        '</div>'
      );
    }

    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-wish-remove]');
      var add = e.target.closest('[data-wish-add]');
      if (rm) {
        ER.toggleWishlist(rm.getAttribute('data-wish-remove'));
        render();
      } else if (add) {
        add.disabled = true;
        ER.addToCart(add.getAttribute('data-wish-add'), 1)
          .then(function () { add.textContent = 'ADDED'; })
          .catch(function () { add.disabled = false; });
      }
    });

    render();
    window.addEventListener('storage', function (e) {
      if (e.key === WISHLIST_KEY) render();
    });
  }

  /* ---------- size guide ----------
     Rows carry inches in data-in; CM is derived (x2.54, 1dp) so the two units
     can't drift. Mirrors SizeGuideSheet in product-detail.tsx. */
  function setSizeGuideUnit(unit) {
    var sheet = document.querySelector('[data-sizeguide]');
    if (!sheet) return;
    sheet.querySelectorAll('[data-sizeguide-unit]').forEach(function (b) {
      var on = b.getAttribute('data-sizeguide-unit') === unit;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    sheet.querySelectorAll('.val[data-in]').forEach(function (cell) {
      var inches = parseFloat(cell.getAttribute('data-in'));
      if (isNaN(inches)) return;
      cell.textContent = unit === 'CM' ? (inches * 2.54).toFixed(1) : String(inches);
    });
  }

  /* ---------- product card sliders (clone-looped scroll-snap) ---------- */
  function initCardSliders(scope) {
    (scope || document).querySelectorAll('[data-pcard-scroller]').forEach(function (el) {
      if (el.dataset.init) return;
      el.dataset.init = '1';
      var count = Number(el.getAttribute('data-count') || 0);
      if (count < 2) return;
      var card = el.closest('[data-pcard]');
      var dots = card ? card.querySelectorAll('[data-pcard-dots] span') : [];
      var offers = card ? card.querySelector('[data-pcard-offers]') : null;
      var badge = card ? card.querySelector('[data-pcard-badge]') : null;

      function setInitial() {
        var w = el.offsetWidth;
        if (!w) return requestAnimationFrame(setInitial);
        el.style.scrollBehavior = 'auto';
        el.scrollLeft = w;
        requestAnimationFrame(function () { el.style.scrollBehavior = ''; });
      }
      setInitial();

      function realIndex() {
        var w = el.offsetWidth;
        if (!w) return 0;
        var idx = Math.round(el.scrollLeft / w);
        if (idx === 0) return count - 1;
        if (idx === count + 1) return 0;
        return idx - 1;
      }

      el.addEventListener('scroll', function () {
        var real = realIndex();
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === real); });
        if (offers) offers.classList.toggle('is-visible', real === 1);
        if (badge) badge.style.opacity = real === 0 ? '1' : '0';
      }, { passive: true });

      function jumpIfOnClone() {
        var w = el.offsetWidth;
        if (!w) return;
        var idx = Math.round(el.scrollLeft / w);
        if (idx === 0 || idx === count + 1) {
          var target = idx === 0 ? count : 1;
          el.style.scrollBehavior = 'auto';
          el.scrollLeft = target * w;
          requestAnimationFrame(function () { el.style.scrollBehavior = ''; });
        }
      }
      if ('onscrollend' in window) {
        el.addEventListener('scrollend', jumpIfOnClone);
      } else {
        var t = null;
        el.addEventListener('scroll', function () {
          if (t) clearTimeout(t);
          t = setTimeout(jumpIfOnClone, 140);
        }, { passive: true });
      }
    });
  }

  /* ---------- PDP ---------- */
  function initPdp() {
    var root = document.querySelector('[data-er-pdp]');
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    var scroller = root.querySelector('[data-pdp-scroller]');
    var dots = root.querySelectorAll('[data-pdp-dots] span');
    if (scroller && dots.length > 1) {
      scroller.addEventListener('scroll', function () {
        var w = scroller.offsetWidth;
        if (!w) return;
        var idx = Math.round(scroller.scrollLeft / w);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });
    }

    var selectedVariant = null;
    var sizes = root.querySelectorAll('[data-pdp-variant]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var low = root.querySelector('[data-pdp-lowstock]');

    function syncLowStock(btn) {
      if (!low) return;
      var stock = Number(btn.getAttribute('data-stock') || 0);
      if (stock > 0 && stock <= 5) {
        low.hidden = false;
        low.querySelector('.msg').textContent = 'Only ' + stock + ' left — order soon';
      } else {
        low.hidden = true;
      }
    }

    sizes.forEach(function (btn) {
      if (btn.classList.contains('is-selected')) {
        selectedVariant = btn.getAttribute('data-pdp-variant');
        syncLowStock(btn);
      }
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        sizes.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selectedVariant = btn.getAttribute('data-pdp-variant');
        if (priceEl && btn.getAttribute('data-price')) priceEl.textContent = btn.getAttribute('data-price');
        syncLowStock(btn);
      });
    });

    var addBtn = root.querySelector('[data-pdp-add]');
    var buyBtn = root.querySelector('[data-pdp-buy]');
    function variantId() {
      return selectedVariant || (addBtn && addBtn.getAttribute('data-default-variant'));
    }
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var id = variantId();
        if (!id) return;
        addBtn.disabled = true;
        ER.addToCart(id, 1)
          .catch(function () {})
          .then(function () { addBtn.disabled = false; });
      });
    }
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        var id = variantId();
        if (!id) return;
        buyBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        })
          .then(function () {
            // Magic Checkout binds clicks, not navigations — a hard redirect to
            // /checkout skips it. ?magicx_open=true is Razorpay's own opener.
            window.location.href = window.__init_magic_x__
              ? '/cart?magicx_open=true'
              : '/checkout';
          })
          .catch(function () { buyBtn.disabled = false; });
      });
    }

    var share = root.querySelector('[data-pdp-share]');
    if (share) {
      share.addEventListener('click', function () {
        var url = window.location.href;
        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).catch(function () {});
        }
      });
    }
  }

  /* ---------- clicks (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var t = function (sel) { return e.target.closest(sel); };

    if (t('[data-sizeguide-open]')) {
      e.preventDefault();
      var sg = document.querySelector('[data-sizeguide]');
      if (sg) {
        sg.hidden = false;
        ER.lock();
      }
    } else if (t('[data-sizeguide-close]')) {
      var sgc = document.querySelector('[data-sizeguide]');
      if (sgc) {
        sgc.hidden = true;
        ER.unlock();
      }
    } else if (t('[data-sizeguide-unit]')) {
      setSizeGuideUnit(t('[data-sizeguide-unit]').getAttribute('data-sizeguide-unit'));
    } else if (t('[data-wish-toggle]')) {
      // Cards are wrapped in product links — don't navigate on a heart tap.
      e.preventDefault();
      e.stopPropagation();
      var heart = t('[data-wish-toggle]');
      var added = ER.toggleWishlist(heart.getAttribute('data-wish-toggle'));
      if (added) {
        heart.classList.remove('er-pcard__heart--bounce');
        void heart.offsetWidth;
        heart.classList.add('er-pcard__heart--bounce');
      }
    } else if (t('[data-menu-open]')) {
      openDrawer(document.getElementById('er-menu'));
    } else if (t('[data-menu-close]')) {
      closeDrawer(document.getElementById('er-menu'));
    } else if (t('[data-cart-open]')) {
      e.preventDefault();
      ER.openCart();
    } else if (t('[data-cart-close]')) {
      ER.closeCart();
    } else if (t('[data-back]')) {
      window.history.back();
    } else if (t('[data-announcement-close]')) {
      localStorage.setItem(ANNOUNCE_KEY, '1');
      var bar = document.querySelector('.er-announcement');
      if (bar) bar.remove();
    } else if (t('[data-discount-apply]')) {
      handleDiscountApply();
    } else if (t('[data-discount-remove]')) {
      localStorage.removeItem(DISCOUNT_KEY); fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{"discount":""}' }).then(function () { ER.refreshCart(); }).catch(function () {});
      applyStashedDiscount();
    } else if (t('[data-cart-plus]')) {
      var el = t('[data-cart-plus]');
      var reload1 = !!el.closest('[data-cart-reload]');
      cartChange(Number(el.getAttribute('data-line')), Number(el.getAttribute('data-qty')) + 1).then(function () {
        if (reload1) window.location.reload();
      });
    } else if (t('[data-cart-minus]')) {
      var el2 = t('[data-cart-minus]');
      var q = Number(el2.getAttribute('data-qty'));
      var reload2 = !!el2.closest('[data-cart-reload]');
      if (q > 1)
        cartChange(Number(el2.getAttribute('data-line')), q - 1).then(function () {
          if (reload2) window.location.reload();
        });
    } else if (t('[data-cart-remove]')) {
      var el3 = t('[data-cart-remove]');
      var reload3 = !!el3.closest('[data-cart-reload]');
      cartChange(Number(el3.getAttribute('data-line')), 0).then(function () {
        if (reload3) window.location.reload();
      });
    } else if (t('[data-quickadd-open]')) {
      var card = t('[data-quickadd-open]').closest('[data-pcard]');
      var sheet = card && card.querySelector('[data-quickadd]');
      if (sheet) {
        sheet.hidden = false;
        ER.lock();
      }
    } else if (t('[data-quickadd-close]')) {
      var qa = t('[data-quickadd-close]').closest('[data-quickadd]');
      if (qa) {
        qa.hidden = true;
        ER.unlock();
      }
    } else if (t('[data-quickadd-variant]')) {
      var vbtn = t('[data-quickadd-variant]');
      var qa2 = vbtn.closest('[data-quickadd]');
      qa2.querySelectorAll('[data-quickadd-variant]').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      vbtn.classList.add('is-selected');
      var confirm = qa2.querySelector('[data-quickadd-confirm]');
      if (confirm) confirm.disabled = false;
    } else if (t('[data-quickadd-confirm]')) {
      var cbtn = t('[data-quickadd-confirm]');
      var qa3 = cbtn.closest('[data-quickadd]');
      var sel = qa3.querySelector('[data-quickadd-variant].is-selected');
      if (sel) {
        cbtn.disabled = true;
        ER.addToCart(sel.getAttribute('data-quickadd-variant'), 1)
          .catch(function () {})
          .then(function () {
            qa3.hidden = true;
            cbtn.disabled = false;
          });
      }
    }

    // close drawers on backdrop click
    if (e.target.matches('[data-drawer-backdrop]')) {
      closeDrawer(e.target.closest('.er-drawer-root'));
      ER.unlock();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.target && e.target.matches && e.target.matches('[data-discount-input]')) {
      e.preventDefault();
      handleDiscountApply();
    }
  });

  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var cart = document.getElementById('er-cart');
      var menu = document.getElementById('er-menu');
      if (cart && !cart.hidden) closeDrawer(cart);
      if (menu && !menu.hidden) closeDrawer(menu);
      var sg = document.querySelector('[data-sizeguide]');
      if (sg && !sg.hidden) {
        sg.hidden = true;
        ER.unlock();
      }
    }
  });

  /* ---------- boot ---------- */
  function boot() {
    initLenis();
    initHeader();
    initAnnouncement();
    applyStashedDiscount();
    initCardSliders(document);
    initPdp();
    syncHearts(document);
    updateWishCount();
    initWishlistPage();
    setSizeGuideUnit('CM'); // storefront default
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-run announcement/header wiring when sections reload
  document.addEventListener('shopify:section:load', function () {
    initHeader();
    initAnnouncement();
    applyStashedDiscount();
    syncHearts(document);
    updateWishCount();
    initWishlistPage();
  });
})(); /* footer-only discount refresh: no item image re-render on coupon apply/remove */ (function(){if(!window.ER||!ER.refreshCart)return;var fullRefresh=ER.refreshCart;function syncDiscountUI(){var code=localStorage.getItem('er:discount-code')||'',field=document.querySelector('[data-discount-form]'),applied=document.querySelector('[data-discount-applied]'),label=document.querySelector('[data-discount-code-label]'),checkout=document.querySelector('[data-checkout-link]');if(applied&&field){applied.hidden=!code;field.hidden=!!code;if(label)label.textContent=code}if(checkout)checkout.setAttribute('href',code?'/discount/'+encodeURIComponent(code)+'?redirect=/checkout':'/checkout')}ER.refreshCart=function(){var live=document.querySelector('#shopify-section-cart-drawer .er-cart__foot');if(!live)return fullRefresh();fetch('/?sections=cart-drawer').then(function(r){return r.json()}).then(function(data){var doc=new DOMParser().parseFromString(data['cart-drawer']||'','text/html');var freshFoot=doc.querySelector('.er-cart__foot');var cur=document.querySelector('#shopify-section-cart-drawer .er-cart__foot');if(freshFoot&&cur){cur.innerHTML=freshFoot.innerHTML;syncDiscountUI()}else{fullRefresh()}}).catch(function(){})}})();
